import React, {useEffect} from "react"
import {cancelPayment} from "../../resources/payment"
import {useModal} from "react-modal-hook"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useToasts} from "react-toast-notifications"
import {CancelConfirmationModal} from "./Payment"
import {Button} from "../Button/Button"

interface CancelPaymentButtonProps {
	paymentId: string
	accessToken: string
	refresh: () => void
	small?: boolean
}

export function CancelPaymentButton({paymentId, accessToken, refresh, small}: CancelPaymentButtonProps) {
	const [cancelState, cancel] = useAsyncResultIdle(cancelPayment)

	const [showCancelConfirmationModal, hideCancelConfirmationModal] = useModal(
		() => (
			<CancelConfirmationModal
				close={hideCancelConfirmationModal}
				onSubmit={async () => {
					await cancel(accessToken, paymentId)
				}}
			/>
		),
		[]
	)
	const {addToast} = useToasts()

	useEffect(() => {
		cancelState.match(
			() => null,
			() => null,
			() => refresh(),
			(e) => addToast(`${e.errors[0].title} - ${e.errors[0].detail}`, {appearance: "error"})
		)
	}, [cancelState])

	return (
		<Button
			size={small ? "small" : "normal"}
			theme="danger"
			variant="outline"
			prefixIcon="disable-delete--interface-essential"
			onClick={() => showCancelConfirmationModal()}
		>
			Cancel
		</Button>
	)
}
